// import { ID, Response } from "../../../../../_metronic/helpers"

import { ID, Response } from "../../../../../../_metronic/helpers"

// import {ID, Response} from '../../../../../../_metronic/helpers'
export type Groupchat = {
  id?: ID
  name?: string
  avatar?: string
  email?: string
  position?: string
  role?: string
  group_name?:string
  chapter_name?:string
 
 
}

export type GroupchatsQueryResponse = Response<Array<Groupchat>>

export const initialGroupchat: Groupchat = {
  avatar: 'avatars/300-6.jpg',
  position: 'Art Director',
  role: 'Administrator',
  name: '',
  email: '',

}
